/**
 * V70-S — 인사관리 > 전사 근로 현황 (KR 전사원)
 *
 * 조직관리 > 조직 근로 현황(OrgWorkStatusPage)의 표·지표·엑셀·월별 상세 모달을 그대로 재사용하고,
 * 조회 대상만 KR 전사원으로 바꾼다 (callable getHrKrWorkStatusMonthly — 권한·KR 범위는 서버 강제).
 */
import React from 'react';
import { OrgWorkStatusPage } from '../org-management/OrgWorkStatusPage';

export function HrCompanyWorkStatusPage() {
  return <OrgWorkStatusPage variant="hrKr" />;
}
